import { styled } from '@linaria/react';
import { breakpoints, layout, semantic, space } from '../../theme/tokens';
import { visuallyHidden } from '../../utils/visuallyHidden';

export const LoadingStatus = styled.span`
  ${visuallyHidden}
`;

export const TopBarSlot = styled.div`
  z-index: 50;
  width: 100%;
  box-sizing: border-box;
  background: ${semantic.bg.canvas};
  padding: ${space['space-800']} ${space['space-600']} 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-1000']} ${space['space-1000']} 0;
  }
`;

export const HeadingArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${space['space-100']} 0 ${space['space-800']};

  & h1 {
    max-width: 12.5em;
  }

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-top: ${space['space-500']};
    padding-bottom: ${space['space-1000']};
  }

  @media (min-width: ${breakpoints.desktop}) {
    padding-right: ${space['space-1200']};
    padding-left: ${space['space-1200']};
  }
`;

export const GridArea = styled.div`
  @media (min-width: ${breakpoints.desktop}) {
    padding: 0
      clamp(
        0px,
        calc((100vw - ${breakpoints.desktop}) * 0.6),
        calc(${space['space-2000']} + ${space['space-1200']})
      );
  }
`;
